import { createTheme } from "@mui/material/styles";

export const PINK = "#EF2D7D";
export const PRIMARY_MAIN = "#FAF8F5";
export const SECONDARY_MAIN = "#212121";

export const COLOR_DEFAULT_BACKGROUND = "#FFFBF5";
export const COLOR_ICON_BACKGROUND = "#FAF4F0";
export const COLOR_LIGHT_GREY = "#E2DFD7";

export const appTheme = createTheme({
  typography: {
    fontFamily: ["Montserrat", "Sanchez"].join(","),
    fontFeatureSettings: "smcp",
  },
  palette: {
    background: {
      default: COLOR_DEFAULT_BACKGROUND,
    },
    primary: {
      main: "#000",
    },
    secondary: {
      main: PINK,
    },
  },
});
